



































import Vue from 'vue'
import Component from 'vue-class-component'
import ListView from '@/components/list/ListView.vue'
import PageTab from '@/components/ui/PageTab.vue'
import { formatDateTimeStringAsDate, formatDateTimeString } from '@/utils/dateUtils'

@Component({
  components: {
    ListView,
    PageTab,
  },
  methods: { formatDateTimeStringAsDate, formatDateTimeString },
})
export default class List extends Vue {
  private listViewKey = 0
  private loading = true

  private isTyreHotel = true

  private tyreHotelId = null
  private orderProductId = null

  private headers = []

  created() {
    if (this.$route.name && !this.$route.name.includes('TyreHotel')) {
      this.isTyreHotel = false
      this.orderProductId = this.$route.params.id
    } else {
      this.tyreHotelId = this.$route.params.id
    }
    this.setHeaders()
    this.loading = false
  }

  private get url() {
    return '/v4/site/stock/history'
  }

  private setHeaders() {
    this.headers = [
      {
        text: 'ID',
        value: 'id',
      },
      {
        text: 'Event',
        value: 'eventText',
        sortable: false,
      },
      {
        text: 'c:stock-history:Cause',
        value: 'causeText',
        sortable: false,
      },
      {
        text: 'User',
        value: 'userName',
        sortable: false,
      },
      {
        text: 'Time',
        value: 'createdAt',
        sortable: false,
      },
    ]

    if (this.isTyreHotel) {
      const causeReferenceHeader = {
        text: 'c:stock-history:Cause reference',
        value: 'causeReference',
        sortable: false,
      }
      this.headers.splice(3, 0, causeReferenceHeader)

      const productHeader = {
        text: 'Product',
        value: 'productName',
      }
      this.headers.splice(6, 0, productHeader)

      const tyreHotelWheelIdHeader = {
        text: 'c:stock-history:Tyre hotel wheel ID',
        value: 'tyreHotelWheelId',
      }
      this.headers.splice(7, 0, tyreHotelWheelIdHeader)

      const transportDateHeader = {
        text: 'c:stock-history:Transport date',
        value: 'transportDate',
      }
      this.headers.splice(8, 0, transportDateHeader)
    }
  }

  private get query() {
    return this.isTyreHotel ? { tyreHotelId: this.tyreHotelId } : { orderProductId: this.orderProductId }
  }
}
